export const routes = [
  {
    path: '/grupoIndicador',
    component: () => import(/* webpackChunkName: "ur" */ './components/List'),
    name: 'grupoIndicador.list'
  }
]
